import { SELECT_PLAN, CLEAR_PLAN } from '../actions/planActions';

// Load initial state from sessionStorage if available
const loadState = () => {
    try {
        const serializedState = sessionStorage.getItem('insurancePlanState');
        if (serializedState === null) {
            return {
                selectedPlan: null,
                timestamp: null
            };
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return {
            selectedPlan: null,
            timestamp: null
        };
    }
};

// Save state to sessionStorage
const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem('insurancePlanState', serializedState);
    } catch (err) {
        // Handle write errors
        console.log('Error saving state:', err);
    }
};

const initialState = loadState();

export default function planReducer(state = initialState, action) {
    let newState;
    switch (action.type) {
        case SELECT_PLAN:
            newState = { ...state, selectedPlan: action.payload, timestamp: Date.now() };
            saveState(newState);
            return newState;
        case CLEAR_PLAN:
            newState = { ...state, selectedPlan: null, timestamp: null };
            saveState(newState);
            return newState;
        default:
            return state;
    }
}